// 根据不同的域名设置不同的 shopId
var currentDomain = window.location.hostname;

// 测试域名变量
if (currentDomain === 'heychic-test-store.myshopify.com') {
    localStorage.setItem('shopId', '66793275449');
}else {
    localStorage.setItem('shopId', '59363262637');
}

// 测试域名
// var heychic_api = 'https://test-user-api.heychic.net';
// 正式域名
var heychic_api = 'https://user-api.heychic.net';

// var shopIdAuth = '66793275449';//测试 
var shopIdAuth = '59363262637';//au
// var shopIdAuth = '79421964578';//usa

// 上传文件至服务器
// var img_video_upload = 'https://tcdn.heychic.net/comment/';//测试
var img_video_upload = 'https://cdn.heychic.net/comment/';//正式

//graphql相关
// var graphql_api = 'https://heychic-test-store.myshopify.com';//测试
var graphql_api = 'https://heychic-com-au.myshopify.com';//正式

// var graphql_token = '2ec63bf90823df5100681407fc939e77';//测试
var graphql_token = '28b6e01d4304fc12c8b514799e0aa497';//正式


// 获取url的token
function getUrlParameter(name) {
    const urlParamsCont = new URLSearchParams(window.location.search);
    return urlParamsCont.get(name);
}
var urlParams_token = getUrlParameter('hc_token');
var authorization = localStorage.getItem('hc_token') || urlParams_token;


// 删除cookie
function deleteAllCookies() {
    console.log("删除cookie")
    localStorage.clear();
    // 获取所有的 cookie
    const cookies = document.cookie.split(';');

    // 遍历所有的 cookie，并将它们的过期时间设置为过去的日期
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
}


// function getCustomerSign(data = {}) {
//   let timestamp = Math.floor(new Date().getTime() / 1000);
//   let nonce_str = generateUniqueId(); // 生成 16 位随机字符串

//   // 处理 data，确保所有值为字符串类型
//   let processed_data = {};
//   Object.keys(data).forEach(key => {
//     processed_data[key] = (data[key] === null || data[key] === undefined) 
//                           ? "" 
//                           : (typeof data[key] === "object" ? JSON.stringify(data[key]) : String(data[key]));
//   });

//   // 添加系统参数
//   processed_data.timestamp = timestamp;
//   processed_data.nonce_str = nonce_str;

//   // 按键排序
//   let sortedKeys = Object.keys(processed_data).sort();

//   // 生成 key=value 形式的字符串
//   let time_data_list = sortedKeys.map(key => `${key}=${processed_data[key]}`).join('&');

//   // 计算 MD5
//   let time_data_md5 = md5(time_data_list);
//   let token_sign = md5(authorization); // 对 token 进行 MD5
//   let sign_str = md5(time_data_md5 + '45f0b16430a64a3d061e75ff13891e0a' + token_sign); // 计算签名

//   // 赋值 sign
//   processed_data.sign = sign_str;

//   return processed_data; // 返回带签名的数据
// }

// 签名js混淆
var _0x1698=['forEach','join','map','stringify','keys','nonce_str','sign'];var _0x3914=function(_0x169862,_0x391443){_0x169862=_0x169862-0x0;let _0x58d762=_0x1698[_0x169862];return _0x58d762;};function getCustomerSign(_0x5c1319={}){let _0x23661c=Math['floor'](new Date()['getTime']()/0x3e8);let _0x1f4a7c=generateUniqueId();let _0x3e2048={};Object[_0x3914('0x4')](_0x5c1319)[_0x3914('0x0')](_0x5f1829=>{_0x3e2048[_0x5f1829]=_0x5c1319[_0x5f1829]===null||_0x5c1319[_0x5f1829]===undefined?'':typeof _0x5c1319[_0x5f1829]==='object'?JSON[_0x3914('0x3')](_0x5c1319[_0x5f1829]):String(_0x5c1319[_0x5f1829]);});_0x3e2048['timestamp']=_0x23661c;_0x3e2048[_0x3914('0x5')]=_0x1f4a7c;let _0x5df518=Object[_0x3914('0x4')](_0x3e2048)['sort']();let _0x58530f=_0x5df518[_0x3914('0x2')](_0x18226f=>_0x18226f+'='+_0x3e2048[_0x18226f])[_0x3914('0x1')]('&');let _0x4aee10=md5(_0x58530f);let _0x5c2a79=md5(authorization);let _0x1c811a=md5(_0x4aee10+'45f0b16430a64a3d061e75ff13891e0a'+_0x5c2a79);_0x3e2048[_0x3914('0x6')]=_0x1c811a;return _0x3e2048;}

// 定义时间格式化方法
function formatUTCToLocal(utcTimeString, format,type) {
  const date = new Date(utcTimeString);
  const year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，所以要加 1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const hour12 = String(date.getHours() % 12 || 12).padStart(2, "0");
	let allTime = '';//时分秒
  const monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (format == "us") {
    monthList.forEach((e, index) => {
      if (index + 1 == month) {
        month = e;
      }
    });
  }

	if(type !== 'review'){
		// review页面不显示时分秒
		if(format == 'us'){
			allTime = `${hour12}:${minutes}:${seconds} ${ampm}`;
		}else{
			allTime = `${hours}:${minutes}:${seconds}`;
		}
	}

  switch (format) {
    case "us":
      return `${month} ${day},${year} ${allTime}`;
    case "au":
      return `${day}/${month}/${year} ${allTime}`;
    default:
      return `${year}-${month}-${day} ${allTime}`;
  }
}

// 获取当前时区
function getCurrentTimeZone() {
    // 获取当前时区与 UTC 的偏移量（单位：分钟）
    var offsetMinutesCoupon = new Date().getTimezoneOffset();
    var offsetHoursCoupon = Math.floor(Math.abs(offsetMinutesCoupon) / 60);
    var signCoupon = offsetMinutesCoupon > 0 ? '-' : '+';

    // 获取时区名称
    var timeZoneNameCoupon = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        offsetHoursCoupon,
        signCoupon,
        timeZoneNameCoupon
    };
}

// 根据时区名称判断地理位置
function getCountryFromTimeZone(timeZoneNameCoupon) {
    if (timeZoneNameCoupon.startsWith('America/') || timeZoneNameCoupon === 'Pacific/Honolulu') {
        return 'us';
    } else if (timeZoneNameCoupon.startsWith('Australia/')) {
        return 'au';
    }
    return 'default';
}

var { timeZoneNameCoupon } = getCurrentTimeZone();
var countryCom = getCountryFromTimeZone(timeZoneNameCoupon);


// 接口组件
// 默认请求头配置
var defaultHeaders = {
    "Content-Type": "application/json",
    Authorization: authorization, // 从你的全局变量中获取
    "X-Shop-Id": shopIdAuth, // 从你的全局变量中获取
};

/**
 * 通用请求函数
 * @param {string} url - 请求的 URL
 * @param {string} method - 请求方法 (GET, POST, PUT, DELETE)
 * @param {object} [customHeaders={}] - 自定义请求头
 * @param {object|null} [body=null] - 请求体 (仅适用于 POST/PUT)
 * @returns {Promise<object>} - 返回一个 Promise，解析为 JSON 数据
 */
function fetchRequest(url, method, customHeaders = {}, body = null) {
    const headers = { ...defaultHeaders, ...customHeaders };
    const options = {
        method,
        headers,
    };

    // 仅在 POST/PUT 请求时添加请求体
    if (body && (method === "POST" || method === "PUT")) {
        options.body = JSON.stringify(body);
    }

    return fetch(url, options)
        .then((response) => {
            if (!response.ok) {
                // 统一处理错误状态
                if (response.status === 401 || response.status === 404) {
                    deleteAllCookies(); // 清除 Cookies
                    window.location.href = "/account/logout"; // 跳转到登出页面
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // 解析 JSON 数据
        })
        .catch((error) => {
            console.error("Request Error:", error);
            throw error; // 将错误抛出供调用者捕获
        });
}


// 调用示例
// GET
/* 
fetchRequest(`${heychic_api}/web/customer/cardWallet`, "GET")
    .then((result) => {
        console.log("GET Result:", result);
    })
    .catch((error) => {
        console.error("GET Error:", error);
    }); 
*/

// POST
/* 
fetchRequest(`${heychic_api}/web/active/sign/signTotalReward`, "POST", {}, { day_num: 7 })
.then((data) => {
    console.log("POST Result:", data);
})
.catch((error) => {
    console.error("POST Error:", error);
});
*/

function getCurrencySymbolAll(currencyCode) {
  const currencySymbols = {
      "USD": "$",
      "EUR": "€",
      "JPY": "¥",
      "GBP": "£",
      "AUD": "$",
      "CAD": "$",
      "CHF": "Fr",
      "CNY": "¥",
      "SEK": "kr",
      "NZD": "$",
      "KRW": "₩",
      "SGD": "$",
      "NOK": "kr",
      "MXN": "$",
      "INR": "₹",
      "RUB": "₽",
      "ZAR": "R",
      "BRL": "R$",
      "TRY": "₺",
      "HKD": "HK$",
      "IDR": "Rp",
      "ISK": "kr",
      "PHP": "₱",
      "DKK": "kr",
      "PLN": "zł",
      "HUF": "Ft",
      "CZK": "Kč",
      "THB": "฿",
      "MYR": "RM",
      "HRK": "kn",
      "RON": "lei",
      "ILS": "₪",
      "CLP": "$",
      "AED": "د.إ",
      "COP": "$",
      "SAR": "﷼",
      "BGN": "лв",
      "PKR": "₨",
      "EGP": "£",
      "DZD": "د.ج",
      "KWD": "د.ك",
      "QAR": "﷼",
      "KES": "KSh",
      "VND": "₫",
      "ARS": "$",
      "TWD": "NT$",
      "BDT": "৳",
      "NPR": "₨",
      "IQD": "ع.د",
      "COP": "COL$",
      "LKR": "Rs",
      "UGX": "USh",
      "GHS": "GH₵",
      "RON": "RON",
      "MAD": "د.م.",
      "UZS": "so'm"
  };

  return currencySymbols[currencyCode] || "Unknown";
}
